import React from 'react';
import sigilExp from "~/assets/sigils/sigil-exp.svg";
import sigilNitro from "~/assets/sigils/sigil-nitro.svg";
import sigilPlus from "~/assets/sigils/sigil-plus.svg";
import sigilIndex from "~/assets/sigils/sigil-index.svg";
import sigilRisingStars from "~/assets/sigils/sigil-rising-stars.svg";
import sigilAkl from "~/assets/sigils/sigil-akl.svg";
import sigilLigagg from "~/assets/sigils/sigil-ligagg.svg";
import sigilEngine from "~/assets/sigils/sigil-engine.svg";
import sigilKaiser from "~/assets/sigils/sigil-kaiser.svg";

interface ProductSigilIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  slug: string;
  isActive?: boolean;
  isComingSoon?: boolean;
  accentColor?: string;
}

export function ProductSigilIcon({ slug, isActive, isComingSoon, accentColor = 'var(--p-epic)', className, style, ...props }: ProductSigilIconProps) {
  const getSrc = () => {
    switch (slug) {
      case 'exp': return sigilExp;
      case 'nitro': return sigilNitro;
      case 'plus': return sigilPlus;
      case 'index': return sigilIndex;
      case 'rising-stars': return sigilRisingStars;
      case 'akl': return sigilAkl;
      case 'ligagg': return sigilLigagg;
      case "engine":
        return sigilEngine;
      case "kaiser":
        return sigilKaiser;
      default: return sigilExp;
    }
  };

  const customProps = {
    ...props,
    className: `transition-all duration-300 object-contain ${className || ''}`,
    style: { 
      ...(isComingSoon ? { opacity: 0.4 } : {}),
      ...style 
    }
  };

  return (
    <img 
      src={getSrc()} 
      alt={`${slug} sigil`}
      width="100%"
      height="100%"
      {...customProps}
    />
  );
}
